// Where the app talks to api.php.
//
// In production this is the relative "/api.php" served by Hostinger next to
// the built app. Locally macOS has no PHP, and CRA's dev server serves
// public/api.php as a static file rather than proxying it, so dev points at
// the Node stand-in (devserver.js) via REACT_APP_API_BASE in .env.development.
const base = process.env.REACT_APP_API_BASE || "";

export const API_URL = `${base}/api.php`;
